 <template>
  <div>
    <div class="wrapper">
      <b-row class="mt-2 mb-2">
        <b-col>
          <b-button class="pull-right" variant="primary" v-b-modal.groupCreate>Groep aanmaken</b-button>
        </b-col>
      </b-row>
      <div class="animated fadeIn">
        <resource-index header="Groepen" endpoint="groups" show-route="groups.view" />
      </div>
    </div>

    <b-modal id="groupCreate" title="Portal gebruiker aanmaken" hide-footer>
      <b-form @submit.prevent="createUser">
        <b-form-group label="Groepsnaam">
          <b-form-input type="text" required v-model="item.name"></b-form-input>
        </b-form-group>
        <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success">Maak groep aan</b-button>
      </b-form>
    </b-modal>
  </div>

</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';
import {addData, getData} from "@/api";

export default {
  name: 'groups',
  components: { ResourceIndex },
  data() {
    return {
      item: {
        name: null,
      },
    }
  },
  methods: {
     
    async createUser() {
      let request = await addData('groups', {
        name: this.item.name,
         
      }).then(response => response);

      if (request.status === 201) {
        return this.$router.push({ name: 'groups.view', params: {id: request.data.data.id}});
      }
    },
    async closeModal() {
      this.$bvModal.hide('modal-1');
      this.item = {
        username: null,
        type: null,
        accountId: null,
        contactId: null,
        invitation: 0,
      };
    }
  },
 

}

</script>
